import { rem } from '@app/utils/sx/functions';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const resendBox: SxProps<Theme> = {
  height: rem(16),
};
